"use strict";

exports.__esModule = true;
exports.accessibleLabelType = exports.dateSetType = exports.dateType = void 0;

require("core-js/modules/es6.array.is-array");

var _is_date = _interopRequireDefault(require("date-fns/is_date"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function isRequiredThunk(baseValidator) {
  return function (props, propName, componentName) {
    var prop = props[propName];

    if (!props[propName]) {
      return new Error("The prop `" + propName + "` is marked as required in `" + componentName + "`, but its value is `" + prop + "`");
    }

    for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      args[_key - 3] = arguments[_key];
    }

    return baseValidator.apply(void 0, [props, propName, componentName].concat(args));
  };
}

var dateType = function dateType(props, propName, componentName) {
  var prop = props[propName];

  if (prop && !(0, _is_date["default"])(prop)) {
    return new Error("Invalid prop `" + propName + "` of type `" + typeof prop + "` supplied to `" + componentName + "`, expected a JavaScript Date instance.");
  }

  return undefined;
};

exports.dateType = dateType;
dateType.isRequired = isRequiredThunk(dateType);

function isDateSet(prop) {
  var isDateArray = Array.isArray(prop) && prop.every(function (item) {
    return (0, _is_date["default"])(item);
  });
  return (0, _is_date["default"])(prop) || isDateArray || typeof prop === 'function';
} // dateType, array of dateType, or function


var dateSetType = function dateSetType(props, propName, componentName) {
  var prop = props[propName];

  if (prop && !isDateSet(prop)) {
    return new Error("Invalid prop `" + propName + "` of type `" + typeof prop + "` supplied to `" + componentName + "`, expected a function, JavaScript Date instance, or an array of JavaScript date instances.");
  }

  return undefined;
};

exports.dateSetType = dateSetType;
dateSetType.isRequired = isRequiredThunk(dateSetType);

var accessibleLabelType = function accessibleLabelType(props, propName, componentName) {
  var prop = props[propName];

  if (!prop) {
    return new Error("In order to properly initialize " + componentName + " in a way that is " + 'accessible to assistive technologies (such as screen readers) a `label` ' + ("prop to " + componentName + " is required"));
  }

  return undefined;
}; // accessible labels are always required


exports.accessibleLabelType = accessibleLabelType;
accessibleLabelType.isRequired = accessibleLabelType;